import Eventbus from '@/core/shared/services/EventBus';
import router from '@/core/routes';
import {
  createRevisionHelpers,
  revisionHelpers,
  Revision,
} from '../../helpers/version';

export const stationIdentityChanged = (
  { commit, dispatch },
  { token, id, version },
) => {
  // DEPRECATION backward compat with <=4.2.15
  const rev = new Revision(version || 'latest');
  rev.deprecateInVersion('4.2.15', () => {
    commit('setToken', token);
    dispatch('updateStationLocally', { id, ...(version ? { version } : {}) }); // only save version when it is defined (aka only when fired from the launcher)
    if (version) {
      createRevisionHelpers(version);
      commit('setDesktopClientVersion', version);
    } else {
      createRevisionHelpers('latest'); // always default to latest version if no version is provided
      commit('setDesktopClientVersion', 'latest');
    }
    router.push({ name: router.currentRoute.name, params: { stationId: id } });
    commit('setGetStationIdentityFlag', true);
  });
};
export const audioChanged = ({ dispatch, rootState }, { volume }) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  const coercedVolume = Math.max(Number(volume), 0); // CEF gives a nullable float (can be negative as well)
  dispatch('updateVolumeWithOptimistic', coercedVolume);
};
export const devicesChanged = ({ dispatch, rootState }, { devices }) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  dispatch('updateDevices', devices);
};
export const appChanged = (
  { dispatch, commit, getters, rootState },
  [running = {}],
) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel

  const {
    runningId = null,
    runningType = null,
    state,
    type = null,
    game = null,
    preset = null,
    ownership = null,
    license = null,
  } = running;
  const isGameRunning =
    runningType === 'game' ||
    runningType === 'tutorial' ||
    runningType === 'unknown_game';
  const hasNoState = !(runningType && runningId);
  const isLauncherRunning = runningType === 'launcher';
  const isVideoReelRunning = runningType === 'video_reel';
  commit('setAppState', {
    runningType,
    runningId,
    state,

    type,
    game,
    preset,
    ownership,
    license,
  });
  if (state !== 'launching') {
    dispatch('endLoading', 'launchingGame'); // legacy end loading for <4.1.5
  }
  // update local state with data from CEF, this is important to allow retrieving the last known state of the launcher
  if (isGameRunning) {
    const playingId = runningId;
    const playingType = runningType === 'unknown_game' ? 'game' : runningType;
    dispatch('updateStationPlayingWithOptimistic', {
      playingId,
      playingType,
    });
    if (getters.timerStatus && !getters.canStart) {
      // ensure overlay are locked if time is up
      dispatch('setDashboard', { visible: true, locked: true });
    }
  } else if (isLauncherRunning || isVideoReelRunning) {
    dispatch('setDashboard', { locked: false });
    dispatch('updateStationPlayingWithOptimistic', {
      playingId: null,
      playingType: null,
    });
  }
  // redirect to relevant routes
  if (isGameRunning || hasNoState) router.push({ name: 'overlay' });
  if (isLauncherRunning) {
    if (!router.currentRoute.name.includes('games-index')) {
      router.push({ name: 'games-index' });
    }
  }
};
export const dashboardChanged = ({ commit, rootState }, { visible }) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  commit('setSessionOverlay', visible);
};
let timeout;
export const idleChanged = (
  { commit, getters, dispatch, state, rootState },
  { idle },
) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  const { currentStation } = getters;
  commit('setSessionIdle', idle);
  // check for service worker updates when it goes idle
  if (timeout) clearTimeout(timeout);
  if (idle && state.volumeBeforeIdle === null) {
    revisionHelpers.deprecateInVersion('3.1.2', () => {
      // DEPRECATION
      commit('setVolumeBeforeIdle', currentStation.volume || 0.5);
      dispatch('setAudio', currentStation.idleModeVolume); // here we store original volume and put the system volume to the max for idleMode
    });
    timeout = setTimeout(() => {
      Eventbus.$emit('sw:check-update');
      timeout = null;
    }, 5000);
  } else if (!idle && state.volumeBeforeIdle !== null) {
    revisionHelpers.deprecateInVersion('3.1.2', () => {
      // DEPRECATION
      dispatch('setAudio', state.volumeBeforeIdle); // here we restore original volume
      commit('setVolumeBeforeIdle', null); // reset value because interop actions can be sent multiple times
    });
  }
};
export const idleModeChanged = (
  { commit, getters, dispatch, state, rootState },
  { running },
) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  const { currentStation } = getters;
  if (currentStation.idleMode !== 'videos') return;
  if (running && state.volumeBeforeIdle === null) {
    commit('setVolumeBeforeIdle', currentStation.volume || 0.5); // here we store original volume and put the system volume to the max for idleMode
    dispatch('setAudio', currentStation.idleModeVolume);
  } else if (!running && state.volumeBeforeIdle !== null) {
    dispatch('setAudio', state.volumeBeforeIdle); // here we restore original volume
    commit('setVolumeBeforeIdle', null); // reset value because interop actions can be sent multiple times
  }
};
export const steamVRChanged = ({ commit, rootState }) => {
  // if (rootState.route.name === 'videoreel') return // ignore for videoreel
};
export const coinOpTriggered = ({ dispatch, rootState }) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  dispatch('createCoinOpBooking');
};
export const getBooking = ({ getters, rootState }) => {
  if (rootState.route.name === 'videoreel') return; // ignore for videoreel
  return getters.currentBookingId || null;
};
